import * as Types from '../../../graphql-types'

import { gql } from '@apollo/client'
import { Content_ProviderCommonFragmentFragmentDoc } from './ContentProviderCommonFragment.generated'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type ContentList_YiTagsListByGroupQueryQueryVariables = Types.Exact<{
  path: Types.Scalars['String']['input']
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>
  language?: Types.InputMaybe<
    Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']
  >
  contentReferencesTo?: Types.InputMaybe<
    | Array<Types.InputMaybe<Types.ContentContentReferencesToFilterInput>>
    | Types.InputMaybe<Types.ContentContentReferencesToFilterInput>
  >
}>

export type ContentList_YiTagsListByGroupQueryQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentReferencesTo?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        contentFrom?: Array<{
          __typename?: 'Content'
          id?: string | null
          language?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          contentProvider?: {
            __typename?: 'ContentProvider'
            providerKey?: string | null
            contentId?: string | null
          } | null
        } | null> | null
      } | null> | null
    } | null> | null
  } | null
}

export const ContentList_YiTagsListByGroupQueryDocument = gql`
  query ContentList_YITagsListByGroupQuery(
    $path: String!
    $offset: Int = 0
    $limit: Int = 25
    $language: [String!] = ["en"]
    $contentReferencesTo: [ContentContentReferencesToFilterInput] = []
  ) {
    contentList(
      offset: $offset
      limit: $limit
      where: { contentType: { eq: "tag" }, path: { eq: $path }, language: { in: $language } }
      contentReferencesTo: $contentReferencesTo
    ) {
      content {
        id
        contentReferencesTo {
          id
          contentFrom(language: $language) {
            id
            language
            title
            contentId
            contentType
            published
            contentProvider {
              ...Content_ProviderCommonFragment
              providerKey
            }
          }
        }
      }
    }
  }
  ${Content_ProviderCommonFragmentFragmentDoc}
`

/**
 * __useContentList_YiTagsListByGroupQueryQuery__
 *
 * To run a query within a React component, call `useContentList_YiTagsListByGroupQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentList_YiTagsListByGroupQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentList_YiTagsListByGroupQueryQuery({
 *   variables: {
 *      path: // value for 'path'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      language: // value for 'language'
 *      contentReferencesTo: // value for 'contentReferencesTo'
 *   },
 * });
 */
export function useContentList_YiTagsListByGroupQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContentList_YiTagsListByGroupQueryQuery,
    ContentList_YiTagsListByGroupQueryQueryVariables
  > &
    (
      | { variables: ContentList_YiTagsListByGroupQueryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContentList_YiTagsListByGroupQueryQuery,
    ContentList_YiTagsListByGroupQueryQueryVariables
  >(ContentList_YiTagsListByGroupQueryDocument, options)
}
export function useContentList_YiTagsListByGroupQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContentList_YiTagsListByGroupQueryQuery,
    ContentList_YiTagsListByGroupQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContentList_YiTagsListByGroupQueryQuery,
    ContentList_YiTagsListByGroupQueryQueryVariables
  >(ContentList_YiTagsListByGroupQueryDocument, options)
}
// @ts-ignore
export function useContentList_YiTagsListByGroupQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ContentList_YiTagsListByGroupQueryQuery,
    ContentList_YiTagsListByGroupQueryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ContentList_YiTagsListByGroupQueryQuery,
  ContentList_YiTagsListByGroupQueryQueryVariables
>
export function useContentList_YiTagsListByGroupQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ContentList_YiTagsListByGroupQueryQuery,
        ContentList_YiTagsListByGroupQueryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ContentList_YiTagsListByGroupQueryQuery | undefined,
  ContentList_YiTagsListByGroupQueryQueryVariables
>
export function useContentList_YiTagsListByGroupQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ContentList_YiTagsListByGroupQueryQuery,
        ContentList_YiTagsListByGroupQueryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ContentList_YiTagsListByGroupQueryQuery,
    ContentList_YiTagsListByGroupQueryQueryVariables
  >(ContentList_YiTagsListByGroupQueryDocument, options)
}
export type ContentList_YiTagsListByGroupQueryQueryHookResult = ReturnType<
  typeof useContentList_YiTagsListByGroupQueryQuery
>
export type ContentList_YiTagsListByGroupQueryLazyQueryHookResult = ReturnType<
  typeof useContentList_YiTagsListByGroupQueryLazyQuery
>
export type ContentList_YiTagsListByGroupQuerySuspenseQueryHookResult = ReturnType<
  typeof useContentList_YiTagsListByGroupQuerySuspenseQuery
>
export type ContentList_YiTagsListByGroupQueryQueryResult = Apollo.QueryResult<
  ContentList_YiTagsListByGroupQueryQuery,
  ContentList_YiTagsListByGroupQueryQueryVariables
>
